// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { ProviderConfiguration } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Configuration/Provider';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useQueryWithOptions } from '../../../other/useQueryWithOptions';

const useRegistryProviderConfiguration: () => UseQueryResult<
  TemplateContract<ProviderConfiguration> | null,
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator, party } = useParties();
  return useQueryWithOptions({
    queryKey: ['queryRegistryProviderConfiguration', operator, party],
    queryFn: async (_, options) => {
      return ledgerApi.queryRegistryProviderConfiguration(options, operator, party);
    },
  });
};

export default useRegistryProviderConfiguration;
